import { REDUX_ACTIONS, GAME_ID } from '../../data/planTorresConstants';

const initialState = {
  rewardMode: false,
  onboardingMode: false,
  standardMode: false,
};

const planTorresGameModeReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.TURN_REWARD_MODE_ON: {
      return {
        ...state,
        rewardMode: true,
      };
    }
    case REDUX_ACTIONS.TURN_REWARD_MODE_OFF: {
      return {
        ...state,
        rewardMode: false,
      };
    }
    case REDUX_ACTIONS.TURN_ONBOARDING_MODE_ON: {
      return {
        ...state,
        onboardingMode: true,
        standardMode: false,
      };
    }
    case REDUX_ACTIONS.TURN_STANDARD_MODE_ON: {
      return {
        ...state,
        onboardingMode: false,
        standardMode: true,
      };
    }
    default:
      return state;
  }
};

export default planTorresGameModeReducer;
